<template>
  <div class="map">
    <div id="map" ref="map" />
  </div>
</template>

<script>
export default {
  props: {
    houses: Array,
    activeHouse: Number
  },
  data() {
    return {
      places: []
    };
  },
  mounted() {
    this.map = new google.maps.Map(this.$refs.map, {
      center: { lat: 50.139754, lng: 14.19974 },
      mapTypeControl: false,
      disableDefaultUI: true,
      zoom: 17,
      mapTypeId: "hybrid"
    });

    this.createHouses(this.houses);
  },
  watch: {
    activeHouse() {
      this.places.forEach((place, index) => {
        if (index === this.activeHouse) {
          place.setOptions({
            strokeColor: "#FF4136",
            fillColor: "#FF4136"
          });
        } else {
          place.setOptions({
            strokeColor: "#fff",
            fillColor: "#fff"
          });
        }
      });
    }
  },
  methods: {
    createHouses(houses) {
      const places = [];
      houses.map(house => {
        const { id, polygon } = house;
        const bounds = new google.maps.LatLngBounds();

        polygon.forEach(point => {
          bounds.extend(point);
        });

        const mapLabel = new MapLabel({
          text: id,
          position: new google.maps.LatLng(
            bounds.getCenter().lat(),
            bounds.getCenter().lng()
          ),
          map: this.map,
          fontSize: 13,
          align: "center",
          zIndex: 100,
          strokeWeight: 4,
          strokeColor: "#000",
          fontColor: "#fff"
        });

        const housePoly = new google.maps.Polygon({
          paths: polygon,
          zIndex: 5,
          strokeColor: "#fff",
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: "#fff",
          fillOpacity: 0.45
        });

        housePoly.setMap(this.map);

        housePoly.addListener("click", () => {
          this.$emit("setActiveHouse", house);
        });

        places.push(housePoly);

        return mapLabel;
      });

      this.places = places;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map {
  height: 100vh;
  width: calc(100% - (100% / 1.618));
  position: fixed;
  left: 0;
  top: 0;
  display: none;
}
@media (min-width: 768px) {
  .map {
    display: block;
  }
}

.map #map {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
